import {SwaggerRepository} from "@/apps/employee-crm-access-api/api/swagger";

export default {
    swagger: new SwaggerRepository(),
}